import React, { useId, useLayoutEffect, useRef, useState } from 'react';

/*
 * secondary text clamped to two lines (lines={1}: one), with a Show more / Show less button only
 * when it is cut.
 * The full text stays in the DOM, so it is selectable and read by screen readers either way.
 */
const ClampText = ({ children, className = '', lines = 2 }) => {
  const ref = useRef(null);
  const id = useId();
  const [open, setOpen] = useState(false);
  const [cut, setCut] = useState(false);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || open) return undefined;
    const check = () => setCut(el.scrollHeight > el.clientHeight + 1);
    check();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [children, open]);
  if (children === null || children === undefined || children === '') return null;
  return (
    <div className={className}>
      <div
        id={id}
        ref={ref}
        className={`tp-sub${open ? '' : ` tp-clamp${lines === 1 ? ' tp-clamp-1' : ''}`}`}
      >
        {children}
      </div>
      {cut || open ? (
        <button
          type="button"
          className="tp-link tp-clamp-toggle"
          aria-expanded={open}
          aria-controls={id}
          onClick={() => setOpen((o) => !o)}
        >
          {open ? 'Show less' : 'Show more'}
        </button>
      ) : null}
    </div>
  );
};

export default ClampText;
